<div class="aya-followups" *ngIf="visibleItems.length">
  <p class="aya-followups-title">Follow-ups</p>
  <ul>
    <li *ngFor="let item of visibleItems">
      <button type="button" (click)="onSelect(item)">
        <span>{{ item }}</span>
        <i class="fal fa-arrow-up-right"></i>
      </button>
    </li>
  </ul>
</div>
